<form [formGroup]="formGroup" (ngSubmit)="submit()">
  <div class="form-field">
    <app-input
      label="EOD Incident Number"
      i18n-label="EOD incident number label@@eodIncidentNumberLabel"
      placeholder="Incident number"
      i18n-placeholder="Incident number placeholder@@incidentNumberPlaceholder"
      formControlName="eodIncidentNumber"
      [touched]="formGroup.get('eodIncidentNumber')?.touched"
      [errorMessage]="formGroup.get('eodIncidentNumber')?.errors">
    </app-input>
  </div>

  <div class="form-field">
    <app-input-select
      label="Incident Type"
      i18n-label="Incident type label@@incidentTypeLabel"
      formControlName="incidentType"
      [required]="true"
      [touched]="formGroup.get('incidentType')?.touched"
      [errorMessage]="formGroup.get('incidentType')?.errors"
      [options]="incidentTypeOptions"></app-input-select>
  </div>

  <div class="form-field">
    <app-input-mock
      label="Reported Date"
      i18n-label="@@reportedDateLabel"
      [value]="heroReport?.createdDate ? (heroReport.createdDate | date : 'yyyy-MM-dd HH:mm') : 'Unknown'"
      i18n-value="Unknown fallback@@unknownValue"
      [touched]="formGroup.get('reportedDate')?.touched"
      [errorMessage]="formGroup.get('reportedDate')?.errors"
      readonly>
    </app-input-mock>
  </div>

  <div class="form-field">
    <app-input-mock
      label="Hero Name"
      i18n-label="@@heroNameLabel"
      [value]="getHeroName(heroReport)"
      [touched]="formGroup.get('heroName')?.touched"
      [errorMessage]="formGroup.get('heroName')?.errors"
      readonly>
    </app-input-mock>
  </div>

  <div class="form-field">
    <app-input-mock
      label="Coordinates"
      i18n-label="@@coordinatesLabel"
      [value]="heroReport?.latitude != null && heroReport?.longitude != null ? (heroReport.latitude + ', ' + heroReport.longitude) : 'Unknown'"
      i18n-value="Unknown fallback@@unknownValue"
      [touched]="formGroup.get('coordinates')?.touched"
      [errorMessage]="formGroup.get('coordinates')?.errors"
      readonly>
      <button
        type="button"
        class="label2-btn"
        (click)="openDirections()"
        [disabled]="!heroReport"
        i18n="Get directions button@@getDirectionsButton">
        Get Directions
      </button>
    </app-input-mock>
  </div>

  <div class="form-field">
    <app-input-mock
      label="Point of Contact"
      i18n-label="@@pointOfContactLabel"
      [value]="heroReport?.pocName || 'Unknown'"
      i18n-value="Unknown fallback@@unknownValue"
      readonly>
    </app-input-mock>
  </div>
</form>